import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=088a8280&"
import script from "./Hint?vue&type=script&lang=ts&"
export * from "./Hint?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports